/* ==========================================================================
   Feature detection
   ========================================================================== */
import "./detect-flex-gap";

/* ==========================================================================
   Polyfill
   ========================================================================== */
import "focus-visible";
import "wicg-inert";

// Polyfill dialog only if there is one and we need to
if (!(document.querySelector("dialog") ?? { showModal: true }).showModal) {
  import("dialog-polyfill").then(({ default: dialogPolyfill }) => {
    document.documentElement.classList.add("dialog-polyfilled");
    for (const dialog of document.querySelectorAll("dialog")) {
      dialogPolyfill.registerDialog(dialog);
    }
  });
}

/* ==========================================================================
   Vendor
   ========================================================================== */
import "lazysizes";
import "lazysizes/plugins/respimg/ls.respimg";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
